import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';
import { apiUc as http } from '../../../http';

class Service extends ServiceCRUD {
  constructor() {
    super('/api/qa/paper');
  }

  createPaper(data) {
    return http.post(this.path, data);
  }

  updateCategories(paperId, data) {
    return http.put(`${this.path}/${paperId}/category`, data);
  }

  updateQuestions(paperId, data) {
    return http.put(`${this.path}/${paperId}/question`, data);
  }

  updateQuestionsGroups(paperId, data) {
    return http.put(`${this.path}/${paperId}/question-group`, data);
  }

  deleteQuestion(paperId, questionId) {
    return http.delete(`${this.path}/${paperId}/question/${questionId}`);
  }

  deleteQuestionGroup(paperId, groupId) {
    return http.delete(`${this.path}/${paperId}/question-group/${groupId}`);
  }
}

export default new Service();
